import { useEffect, useState } from 'react'; 
import { Provider } from 'react-redux';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { store } from '../../state';
import Wrapper from "../../components/Wrapper";
import { WITHDRAW_URL } from '../../components/constants';
import { useUserContext } from '../../components/UserContext';

interface WithdrawalsProps {
  msisdn: string; // Define the msisdn prop type
  bal:number,
    minBal:number,
}

const Withdrawals:React.FC<WithdrawalsProps> = ({ msisdn, minBal, bal }) => {
  const [amount,setAmount] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [responseDesc, setResponseDesc] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); 
  const [showFail, setShowFail] = useState(false);
  const {defaultMinBal, defaultBal, setDefaultBal, setDefaultMinBal } = useUserContext();
  const [loading, setLoading] = useState(false);
  // Utilize the msisdn prop
  useEffect(() => {
    //console.log('msisdn in Races:', msisdn);
    // You can perform actions based on the msisdn value here
  }, [msisdn]); // Add msisdn to the dependency array if used in useEffect

  const submit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setLoading(true);
    const wAmount = parseFloat(amount);
    if( minBal < wAmount){
      setShowFail(true);
      setErrorMessage('you can only withdraw a maximum of '+ minBal);
      setLoading(false);
    }else{
      try {
        const userAgent = navigator.userAgent;
        const { data } = await axios.post(`${WITHDRAW_URL}`, {
          "Msisdn": msisdn?.toString() || "", 
          "Amount": wAmount, 
          "Occasion": "payment",
          "SourceApp":"WEB" + userAgent,
          "Salt": "ggfg4545fgfgt4t454"
        });
     
        if(data.success === true) {
          setShowSuccess(true);
          setResponseDesc(data.message); 
          setDefaultBal(data.bal);
          setDefaultMinBal(data.min_bal);
          setLoading(false);
          // Hide the success message after a certain period
          setTimeout(() => {
            setShowSuccess(false);
          }, 3000); // Adjust the duration as needed
    
          setTimeout(() => {
            setRedirect(true);
          }, 3000); 
    
        }else{
          setShowFail(true);
          setErrorMessage(data.message);
        }
    
         // console.log(data);
       
      } catch (error) {
         // console.error('Topup request Failed:', error);
         setLoading(false);
         setShowFail(true);
         setErrorMessage("Failed to connect");
      }
    }
  
   
  };
  
  if (redirect) {
    return <Navigate to={'/'}  />;
  }
    return (<>
      <Wrapper  msisdn={msisdn}>
    <Provider store={store}>
      <form onSubmit={submit}>
      <div className="container bg-lime-400 h-screen opacity-70 place-items-center ">
         <div className='flex items-center justify-center h-screen bg-black rounded-md shadow-md m-2' > 
         <div className="flex flex-col items-center">
            {/* Div showing default balance */}
            <div className="bg-gray-800 text-white p-2 rounded-md mb-4">
                      {/* Your content */}
                    Bal: <span className='text-5xl'>{defaultBal}</span><p/>
                    Available: {defaultMinBal} <p/>
            </div>
        
         <div className="mx-8 bg-white p-4 rounded-lg shadow-md flex flex-col sm:flex-row items-center justify-center gap-y-2">
    <input
      type="number"
      className="border font-extrabold border-gray-300 rounded-md px-3 py-2 mr-2 focus:outline-none"
      placeholder="Amount"
      onChange={(e) => setAmount(e.target.value)}
      required
    />
    <button className="bg-green-500 font-extrabold hover:bg-green-600 text-white py-2 px-4 rounded-md shadow-md transition duration-300">
      Withdraw
    </button>
  </div>
         </div>
        
</div>
      </div>
      </form>

      {showSuccess && (
        <div className="bg-green-500 text-white p-4 absolute top-0 right-0 mt-10 mr-10 rounded">
          {responseDesc}
        </div>
        )}

      {showFail && (
        <div className="bg-red-500 text-white p-4 absolute top-0 justify-center mt-10 mr-10 rounded">
          {errorMessage}
        </div>
      )}

      {/* Spinner */}
      {loading && (
        <div className="flex justify-center items-center fixed top-0 left-0 w-full h-full bg-gray-600 bg-opacity-75 z-50">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900"></div>
        </div>
      )}

    </Provider >
    </Wrapper>
    </>);
};

export default Withdrawals;